export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  description: string;
  category: string;
  categorySlug: string;
  tags: string[];
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  favorites: number;
  totalChapters: number;
  chapters: ComicChapter[];
  updatedAt: string;
  publishedAt: string;
}

export interface Category {
  name: string;
  slug: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  { name: '热血动作', slug: 'rexue-dongzuo', icon: 'ri-fire-line', count: 128 },
  { name: '恋爱言情', slug: 'lianai-yanqing', icon: 'ri-heart-line', count: 156 },
  { name: '悬疑推理', slug: 'xuanyi-tuili', icon: 'ri-search-eye-line', count: 89 },
  { name: '奇幻冒险', slug: 'qihuan-maoxian', icon: 'ri-magic-line', count: 112 },
  { name: '搞笑日常', slug: 'gaoxiao-richang', icon: 'ri-emotion-laugh-line', count: 95 },
  { name: '恐怖惊悚', slug: 'kongbu-jingsong', icon: 'ri-ghost-line', count: 67 },
  { name: '耽美BL', slug: 'danmei-bl', icon: 'ri-user-heart-line', count: 143 },
  { name: '百合GL', slug: 'baihe-gl', icon: 'ri-women-line', count: 52 },
  { name: '古风武侠', slug: 'gufeng-wuxia', icon: 'ri-sword-line', count: 78 },
  { name: '都市生活', slug: 'dushi-shenghuo', icon: 'ri-building-line', count: 104 },
];

export const comics: Comic[] = [
  {
    id: 'comic-1',
    title: '剑与魔法',
    author: '金贤秀',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20fantasy%20comic%20cover%20art%2C%20sword%20and%20magic%20theme%2C%20male%20warrior%20protagonist%20with%20dark%20hair%2C%20dramatic%20lighting%2C%20manga%20illustration%20style%2C%20vibrant%20warm%20colors%2C%20clean%20white%20background%2C%20professional%20webtoon%20cover&width=400&height=560&seq=manhwa-cover-01&orientation=portrait',
    description: '在剑与魔法交织的世界中，年轻的冒险者踏上寻找传说之剑的旅途。面对强大的敌人和未知的危险，他必须不断成长，揭开隐藏在历史背后的真相。这是一部充满热血与感动的奇幻冒险故事，带你感受最纯粹的韩漫魅力。',
    category: '奇幻冒险',
    categorySlug: 'qihuan-maoxian',
    tags: ['奇幻', '冒险', '热血', '成长'],
    status: '连载中',
    rating: 9.2,
    views: 1285000,
    favorites: 89200,
    totalChapters: 156,
    chapters: [
      { id: 'ch-1-156', title: '第156话 觉醒之力', number: 156, updatedAt: '2026-08-04' },
      { id: 'ch-1-155', title: '第155话 最后的试炼', number: 155, updatedAt: '2026-07-28' },
      { id: 'ch-1-154', title: '第154话 隐藏的力量', number: 154, updatedAt: '2026-07-21' },
      { id: 'ch-1-153', title: '第153话 命运之轮', number: 153, updatedAt: '2026-07-14' },
      { id: 'ch-1-152', title: '第152话 新的征程', number: 152, updatedAt: '2026-07-07' },
    ],
    updatedAt: '2026-08-04',
    publishedAt: '2023-03-15',
  },
  {
    id: 'comic-2',
    title: '恋爱信号',
    author: '李智恩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%20art%2C%20beautiful%20couple%20in%20cherry%20blossom%20scene%2C%20soft%20pastel%20warm%20colors%2C%20shojo%20manga%20illustration%20style%2C%20clean%20white%20background%2C%20professional%20webtoon%20cover%20design&width=400&height=560&seq=manhwa-cover-02&orientation=portrait',
    description: '平凡的大学生林小夏，在一天之内连续收到了三条神秘的恋爱信号。从此她的生活变得不再平凡——三个性格迥异的男生同时出现在她的生活中。甜蜜又纠结的校园恋爱故事，带你重温心动的感觉。',
    category: '恋爱言情',
    categorySlug: 'lianai-yanqing',
    tags: ['恋爱', '校园', '甜蜜', '日常'],
    status: '连载中',
    rating: 9.5,
    views: 2150000,
    favorites: 156300,
    totalChapters: 89,
    chapters: [
      { id: 'ch-2-89', title: '第89话 心动的选择', number: 89, updatedAt: '2026-08-03' },
      { id: 'ch-2-88', title: '第88话 雨中的告白', number: 88, updatedAt: '2026-07-27' },
      { id: 'ch-2-87', title: '第87话 意外的相遇', number: 87, updatedAt: '2026-07-20' },
      { id: 'ch-2-86', title: '第86话 藏不住的心意', number: 86, updatedAt: '2026-07-13' },
      { id: 'ch-2-85', title: '第85话 夏日的约定', number: 85, updatedAt: '2026-07-06' },
    ],
    updatedAt: '2026-08-03',
    publishedAt: '2024-01-10',
  },
  {
    id: 'comic-3',
    title: '暗夜追踪者',
    author: '朴志浩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20thriller%20manhwa%20cover%20art%2C%20dark%20detective%20noir%20style%2C%20male%20detective%20in%20trench%20coat%2C%20mysterious%20night%20cityscape%2C%20dramatic%20shadows%2C%20clean%20white%20background%2C%20professional%20webtoon%20cover&width=400&height=560&seq=manhwa-cover-03&orientation=portrait',
    description: '首尔深夜接连发生神秘失踪案件，刑警韩志勋在调查中发现，这些案件背后隐藏着一个惊天阴谋。每一个线索都指向十年前的一桩未解悬案。紧张刺激的悬疑推理，带你一步步揭开真相的面纱。',
    category: '悬疑推理',
    categorySlug: 'xuanyi-tuili',
    tags: ['悬疑', '推理', '犯罪', '都市'],
    status: '已完结',
    rating: 9.0,
    views: 980000,
    favorites: 72300,
    totalChapters: 72,
    chapters: [
      { id: 'ch-3-72', title: '第72话 真相大白（终章）', number: 72, updatedAt: '2026-06-15' },
      { id: 'ch-3-71', title: '第71话 最后的线索', number: 71, updatedAt: '2026-06-08' },
      { id: 'ch-3-70', title: '第70话 幕后黑手', number: 70, updatedAt: '2026-06-01' },
      { id: 'ch-3-69', title: '第69话 生死时速', number: 69, updatedAt: '2026-05-25' },
      { id: 'ch-3-68', title: '第68话 关键证据', number: 68, updatedAt: '2026-05-18' },
    ],
    updatedAt: '2026-06-15',
    publishedAt: '2024-06-20',
  },
  {
    id: 'comic-4',
    title: '魔王大人的日常',
    author: '崔允儿',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20comedy%20manhwa%20cover%20art%2C%20chibi%20demon%20lord%20character%20doing%20everyday%20activities%2C%20colorful%20playful%20style%2C%20funny%20expressions%2C%20warm%20bright%20colors%2C%20clean%20white%20background%2C%20professional%20webtoon%20cover&width=400&height=560&seq=manhwa-cover-04&orientation=portrait',
    description: '统治魔界三千年的魔王大人，因为厌倦了打打杀杀的生活，决定退休到人间过普通日子。然而，习惯了发号施令的魔王，在便利店打工、坐地铁通勤的日常中闹出了无数笑话。轻松搞笑的日常喜剧，保证让你笑到停不下来！',
    category: '搞笑日常',
    categorySlug: 'gaoxiao-richang',
    tags: ['搞笑', '日常', '魔王', '轻松'],
    status: '连载中',
    rating: 8.8,
    views: 756000,
    favorites: 48900,
    totalChapters: 134,
    chapters: [
      { id: 'ch-4-134', title: '第134话 魔王学做饭', number: 134, updatedAt: '2026-08-02' },
      { id: 'ch-4-133', title: '第133话 超市大作战', number: 133, updatedAt: '2026-07-26' },
      { id: 'ch-4-132', title: '第132话 邻居的秘密', number: 132, updatedAt: '2026-07-19' },
      { id: 'ch-4-131', title: '第131话 魔王的休假', number: 131, updatedAt: '2026-07-12' },
      { id: 'ch-4-130', title: '第130话 人间的节日', number: 130, updatedAt: '2026-07-05' },
    ],
    updatedAt: '2026-08-02',
    publishedAt: '2023-11-08',
  },
  {
    id: 'comic-5',
    title: '血月之夜',
    author: '姜贤宇',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20horror%20manhwa%20cover%20art%2C%20red%20moon%20night%20scene%2C%20mysterious%20female%20protagonist%20with%20long%20dark%20hair%2C%20gothic%20horror%20atmosphere%2C%20dark%20warm%20tones%2C%20clean%20white%20background%2C%20professional%20webtoon%20cover&width=400&height=560&seq=manhwa-cover-05&orientation=portrait',
    description: '每当血月升起，小镇上就会发生离奇死亡事件。转学生金素妍来到这个被诅咒的小镇后，发现自己能看见别人看不见的东西。恐怖与悬疑交织的惊悚故事，让你在深夜阅读时后背发凉。',
    category: '恐怖惊悚',
    categorySlug: 'kongbu-jingsong',
    tags: ['恐怖', '惊悚', '超自然', '悬疑'],
    status: '连载中',
    rating: 8.5,
    views: 632000,
    favorites: 38700,
    totalChapters: 48,
    chapters: [
      { id: 'ch-5-48', title: '第48话 血月再现', number: 48, updatedAt: '2026-08-01' },
      { id: 'ch-5-47', title: '第47话 古老的诅咒', number: 47, updatedAt: '2026-07-25' },
      { id: 'ch-5-46', title: '第46话 消失的村庄', number: 46, updatedAt: '2026-07-18' },
      { id: 'ch-5-45', title: '第45话 深夜的低语', number: 45, updatedAt: '2026-07-11' },
      { id: 'ch-5-44', title: '第44话 镜中的倒影', number: 44, updatedAt: '2026-07-04' },
    ],
    updatedAt: '2026-08-01',
    publishedAt: '2025-02-14',
  },
  {
    id: 'comic-6',
    title: '武道至尊',
    author: '张成勋',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20martial%20arts%20manhwa%20cover%20art%2C%20powerful%20male%20fighter%20in%20dynamic%20action%20pose%2C%20energy%20aura%20effect%2C%20shonen%20battle%20manga%20style%2C%20warm%20fiery%20colors%2C%20clean%20white%20background%2C%20professional%20webtoon%20cover&width=400&height=560&seq=manhwa-cover-06&orientation=portrait',
    description: '武道世家出身的少年李烈，因家族被灭门而踏上了复仇之路。在修炼之路上，他遇到了形形色色的对手和伙伴，一步步成长为真正的武道至尊。拳拳到肉的热血战斗，让你肾上腺素飙升！',
    category: '热血动作',
    categorySlug: 'rexue-dongzuo',
    tags: ['热血', '武道', '复仇', '战斗'],
    status: '连载中',
    rating: 9.3,
    views: 1520000,
    favorites: 100500,
    totalChapters: 198,
    chapters: [
      { id: 'ch-6-198', title: '第198话 巅峰对决', number: 198, updatedAt: '2026-08-05' },
      { id: 'ch-6-197', title: '第197话 突破极限', number: 197, updatedAt: '2026-07-29' },
      { id: 'ch-6-196', title: '第196话 最后一击', number: 196, updatedAt: '2026-07-22' },
      { id: 'ch-6-195', title: '第195话 生死之战', number: 195, updatedAt: '2026-07-15' },
      { id: 'ch-6-194', title: '第194话 绝境求生', number: 194, updatedAt: '2026-07-08' },
    ],
    updatedAt: '2026-08-05',
    publishedAt: '2022-09-01',
  },
  {
    id: 'comic-7',
    title: '星月童话',
    author: '韩美英',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20GL%20romance%20manhwa%20cover%20art%2C%20two%20beautiful%20women%20under%20starry%20night%20sky%2C%20soft%20romantic%20atmosphere%2C%20gentle%20warm%20colors%2C%20yuri%20manga%20style%2C%20clean%20white%20background%2C%20professional%20webtoon%20cover&width=400&height=560&seq=manhwa-cover-07&orientation=portrait',
    description: '音乐学院的两位天才少女——钢琴系的李星河和小提琴系的韩月儿，在一次联合演出中擦出了不一样的火花。在音乐的世界里，她们彼此理解、互相成就，谱写了一段超越世俗眼光的浪漫恋曲。',
    category: '百合GL',
    categorySlug: 'baihe-gl',
    tags: ['百合', '音乐', '校园', '治愈'],
    status: '已完结',
    rating: 9.1,
    views: 568000,
    favorites: 45200,
    totalChapters: 60,
    chapters: [
      { id: 'ch-7-60', title: '第60话 星月永恒（终章）', number: 60, updatedAt: '2026-05-30' },
      { id: 'ch-7-59', title: '第59话 舞台之上', number: 59, updatedAt: '2026-05-23' },
      { id: 'ch-7-58', title: '第58话 心的旋律', number: 58, updatedAt: '2026-05-16' },
      { id: 'ch-7-57', title: '第57话 勇敢的一步', number: 57, updatedAt: '2026-05-09' },
      { id: 'ch-7-56', title: '第56话 星空下的约定', number: 56, updatedAt: '2026-05-02' },
    ],
    updatedAt: '2026-05-30',
    publishedAt: '2024-08-15',
  },
  {
    id: 'comic-8',
    title: '江南风云',
    author: '刘泰宇',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20historical%20wuxia%20manhwa%20cover%20art%2C%20ancient%20Korean%20warrior%20in%20traditional%20hanbok%20with%20sword%2C%20mountain%20landscape%2C%20ink%20wash%20painting%20style%2C%20warm%20earthy%20colors%2C%20clean%20white%20background%2C%20professional%20webtoon%20cover&width=400&height=560&seq=manhwa-cover-08&orientation=portrait',
    description: '在古朝鲜时期的江南地区，一场关于权力与正义的较量悄然展开。出身卑微的少年朴泰俊凭借过人的智慧与勇气，在乱世中一步步崛起，最终成为改变时代格局的风云人物。气势恢宏的古风武侠巨作。',
    category: '古风武侠',
    categorySlug: 'gufeng-wuxia',
    tags: ['古风', '武侠', '历史', '权谋'],
    status: '连载中',
    rating: 9.0,
    views: 845000,
    favorites: 62100,
    totalChapters: 112,
    chapters: [
      { id: 'ch-8-112', title: '第112话 风云际会', number: 112, updatedAt: '2026-08-04' },
      { id: 'ch-8-111', title: '第111话 朝堂之上', number: 111, updatedAt: '2026-07-28' },
      { id: 'ch-8-110', title: '第110话 暗流涌动', number: 110, updatedAt: '2026-07-21' },
      { id: 'ch-8-109', title: '第109话 棋逢对手', number: 109, updatedAt: '2026-07-14' },
      { id: 'ch-8-108', title: '第108话 江湖之路', number: 108, updatedAt: '2026-07-07' },
    ],
    updatedAt: '2026-08-04',
    publishedAt: '2023-07-20',
  },
  {
    id: 'comic-9',
    title: '他的温度',
    author: '文彩英',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20BL%20romance%20manhwa%20cover%20art%2C%20two%20handsome%20men%20facing%20each%20other%20with%20tender%20expression%2C%20warm%20sunset%20lighting%2C%20boys%20love%20manga%20style%2C%20soft%20warm%20colors%2C%20clean%20white%20background%2C%20professional%20webtoon%20cover&width=400&height=560&seq=manhwa-cover-09&orientation=portrait',
    description: '冷面总裁金道允与温暖画家李河蓝，两个看似毫无交集的人，因为一次偶然的画展相遇。冰与火的碰撞，让彼此的世界都发生了微妙的变化。细腻动人的情感描写，温暖治愈的都市爱情故事。',
    category: '耽美BL',
    categorySlug: 'danmei-bl',
    tags: ['耽美', '都市', '治愈', '总裁'],
    status: '连载中',
    rating: 9.4,
    views: 1890000,
    favorites: 132800,
    totalChapters: 76,
    chapters: [
      { id: 'ch-9-76', title: '第76话 靠近的心', number: 76, updatedAt: '2026-08-03' },
      { id: 'ch-9-75', title: '第75话 画中的你', number: 75, updatedAt: '2026-07-27' },
      { id: 'ch-9-74', title: '第74话 深夜来电', number: 74, updatedAt: '2026-07-20' },
      { id: 'ch-9-73', title: '第73话 温柔的距离', number: 73, updatedAt: '2026-07-13' },
      { id: 'ch-9-72', title: '第72话 心之所向', number: 72, updatedAt: '2026-07-06' },
    ],
    updatedAt: '2026-08-03',
    publishedAt: '2024-03-20',
  },
  {
    id: 'comic-10',
    title: '社内恋爱禁止令',
    author: '安秀晶',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20office%20romance%20manhwa%20cover%20art%2C%20stylish%20business%20couple%20in%20modern%20office%20setting%2C%20chic%20urban%20style%2C%20warm%20sophisticated%20colors%2C%20clean%20white%20background%2C%20professional%20webtoon%20cover%20design&width=400&height=560&seq=manhwa-cover-10&orientation=portrait',
    description: '广告公司的新人策划金多美，入职第一天就发现直属上司是自己大学时的暗恋对象——那个她曾经告白被拒的学长。公司明令禁止办公室恋情，但朝夕相处中，两颗心却在不知不觉中靠近。职场与爱情的双重博弈，甜蜜又刺激。',
    category: '都市生活',
    categorySlug: 'dushi-shenghuo',
    tags: ['都市', '职场', '恋爱', '办公室'],
    status: '连载中',
    rating: 9.0,
    views: 1100000,
    favorites: 78500,
    totalChapters: 94,
    chapters: [
      { id: 'ch-10-94', title: '第94话 秘密约会', number: 94, updatedAt: '2026-08-05' },
      { id: 'ch-10-93', title: '第93话 项目危机', number: 93, updatedAt: '2026-07-29' },
      { id: 'ch-10-92', title: '第92话 意外的助攻', number: 92, updatedAt: '2026-07-22' },
      { id: 'ch-10-91', title: '第91话 加班之夜', number: 91, updatedAt: '2026-07-15' },
      { id: 'ch-10-90', title: '第90话 心照不宣', number: 90, updatedAt: '2026-07-08' },
    ],
    updatedAt: '2026-08-05',
    publishedAt: '2024-05-10',
  },
  {
    id: 'comic-11',
    title: '烈火战队',
    author: '郑太浩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20action%20manhwa%20cover%20art%2C%20firefighter%20team%20in%20heroic%20pose%2C%20flames%20and%20smoke%20background%20effect%2C%20intense%20dramatic%20style%2C%20warm%20orange%20and%20red%20tones%2C%20clean%20white%20background%2C%20professional%20webtoon%20cover&width=400&height=560&seq=manhwa-cover-11&orientation=portrait',
    description: '一群年轻的消防员在烈火与危险中守护城市的故事。队长姜大浩带领着他的"烈火战队"，每一次出警都是与死神的赛跑。热血、友情、牺牲与成长，这是一部致敬逆行者的热血力作。',
    category: '热血动作',
    categorySlug: 'rexue-dongzuo',
    tags: ['热血', '消防', '英雄', '友情'],
    status: '连载中',
    rating: 9.1,
    views: 923000,
    favorites: 67800,
    totalChapters: 82,
    chapters: [
      { id: 'ch-11-82', title: '第82话 火场救援', number: 82, updatedAt: '2026-08-02' },
      { id: 'ch-11-81', title: '第81话 生死一线', number: 81, updatedAt: '2026-07-26' },
      { id: 'ch-11-80', title: '第80话 新的挑战', number: 80, updatedAt: '2026-07-19' },
      { id: 'ch-11-79', title: '第79话 战友之情', number: 79, updatedAt: '2026-07-12' },
      { id: 'ch-11-78', title: '第78话 烈火雄心', number: 78, updatedAt: '2026-07-05' },
    ],
    updatedAt: '2026-08-02',
    publishedAt: '2024-07-01',
  },
  {
    id: 'comic-12',
    title: '异世界便利店',
    author: '孙艺珍',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20comedy%20isekai%20manhwa%20cover%20art%2C%20convenience%20store%20in%20fantasy%20world%2C%20cute%20elf%20and%20human%20characters%2C%20colorful%20whimsical%20style%2C%20warm%20bright%20colors%2C%20clean%20white%20background%2C%20professional%20webtoon%20cover&width=400&height=560&seq=manhwa-cover-12&orientation=portrait',
    description: '普通大学生张佑镇一觉醒来发现自己穿越到了剑与魔法的异世界——带的只有一家便利店。用现代的零食、泡面和日用品征服异世界居民的心？当魔法师爱上辣炒年糕，当骑士沉迷于泡面，这场异世界冒险注定不平凡。',
    category: '搞笑日常',
    categorySlug: 'gaoxiao-richang',
    tags: ['异世界', '搞笑', '美食', '穿越'],
    status: '连载中',
    rating: 8.7,
    views: 1020000,
    favorites: 71000,
    totalChapters: 65,
    chapters: [
      { id: 'ch-12-65', title: '第65话 泡面的魔力', number: 65, updatedAt: '2026-08-04' },
      { id: 'ch-12-64', title: '第64话 精灵族的订单', number: 64, updatedAt: '2026-07-28' },
      { id: 'ch-12-63', title: '第63话 魔王的零食', number: 63, updatedAt: '2026-07-21' },
      { id: 'ch-12-62', title: '第62话 新的商品', number: 62, updatedAt: '2026-07-14' },
      { id: 'ch-12-61', title: '第61话 异世界美食节', number: 61, updatedAt: '2026-07-07' },
    ],
    updatedAt: '2026-08-04',
    publishedAt: '2025-01-05',
  },
];

export const featuredComicIds = ['comic-1', 'comic-6', 'comic-2', 'comic-9'];

export const hotComicIds = ['comic-6', 'comic-2', 'comic-9', 'comic-1', 'comic-10', 'comic-3', 'comic-12', 'comic-4'];

export const latestComicIds = ['comic-10', 'comic-6', 'comic-1', 'comic-8', 'comic-12', 'comic-2', 'comic-9', 'comic-11'];

export const siteInfo = {
  name: '51漫画网',
  slogan: '韩国漫画，无删减漫画，下拉式阅读，免费韩漫大全',
  description: '51漫画网提供无删减韩国漫画下拉式阅读服务，免费韩漫大全题材丰富多样，更新及时、资源优质，为您打造便捷高效的韩漫阅读平台。',
  url: 'https://www.51manhua.com',
  email: 'contact@51manhua.com',
  founded: '2020',
  totalComics: 1024,
  totalUsers: 3500000,
  dailyVisitors: 280000,
};

export const faqs = [
  {
    question: '51漫画网是免费的吗？',
    answer: '是的，51漫画网上的所有韩国漫画均为免费阅读。我们致力于为广大韩漫爱好者提供高质量的免费阅读服务，无需注册即可畅读所有漫画。',
  },
  {
    question: '什么是下拉式阅读？',
    answer: '下拉式阅读是韩国漫画（Webtoon）的特色阅读方式。您只需向下滚动页面，漫画内容便会自然流畅地展示，无需翻页操作。这种阅读方式特别适合手机端阅读，让您获得沉浸式的韩漫阅读体验。',
  },
  {
    question: '漫画更新频率如何？',
    answer: '51漫画网与多家韩国漫画平台合作，确保漫画更新及时。大部分热门连载漫画保持每周更新，部分作品可能根据原作更新周期调整。您可以在漫画详情页查看具体的更新日期。',
  },
  {
    question: '是否需要注册账号？',
    answer: '目前51漫画网无需注册即可阅读所有漫画内容。如果您希望收藏喜爱的漫画或订阅更新提醒，可以选择注册账号，享受更便捷的个性化阅读体验。',
  },
  {
    question: '支持哪些设备阅读？',
    answer: '51漫画网采用响应式设计，完美适配电脑、平板和手机等各类设备。无论您使用什么设备，都能获得流畅舒适的下拉式阅读体验。',
  },
  {
    question: '如何查找想看的漫画？',
    answer: '您可以通过首页的分类导航浏览不同类型漫画，也可以使用搜索功能直接查找漫画名称。我们还在首页设置了"热门推荐"和"最新更新"板块，方便您发现更多优质韩漫。',
  },
];